export default __webpack_public_path__ + "static/media/biggest-area.ed071448.svg";